import ApiBase from './ApiBase';

export default class OrderService extends ApiBase {
  constructor(apiBaseUrl: string) {
    super(apiBaseUrl);
    this.baseUrl = '/api';
  }

  async find(email: string, orderNumber: string, storeId?: string) {
    const params: Record<string, string> = {
      email: email.trim(),
      order: orderNumber.trim(),
    };

    if (storeId) {
      params.storeId = storeId;
    }

    const { data } = await this.client.get(`/order-lookup/claim`, {
      params,
    });

    return data;
  }

  async searchProducts(body: { productName: string; storeId: string; limit: number; skip: number }) {
    const { data } = await this.client.get(`/orders/${body.storeId}/products/query`, {
      params: {
        name: body.productName,
        limit: body.limit,
        skip: body.skip,
      },
    });

    return data;
  }
}
